import {WhatIfScenarioConfig, WhatIfScenarioInputValues, WhatIfScenarioRecord} from "../../ps-types";
import {Container, Grid} from "semantic-ui-react";
import {LocatorsMapInput} from "./LocatorsMapInput";
import { LoadfromDataSourceBtn } from "./LoadFromDataSourceBtn";

export function GlobalInputs({config, inputData, updateInputData, renderHeaderSection = true, compact = false, sectioningByWorksheet, useDatePickersForDateInputs = false}: {
  config: WhatIfScenarioConfig,
  inputData: WhatIfScenarioRecord['inputData'],
  updateInputData: (scenario: WhatIfScenarioRecord['inputData']) => void,
  renderHeaderSection?: boolean,
  compact?: boolean,
  sectioningByWorksheet?: {
    customMapping?: Record<string, string[]>;
  },
  useDatePickersForDateInputs?: boolean
}) {

  const globalInputs = inputData.globalInputs!;

  const handleOnValuesUpdated = (values: WhatIfScenarioInputValues) => {
    let updatedGlobalInputs: WhatIfScenarioInputValues = {...(inputData?.globalInputs ?? {}), ...values};
    updateInputData({...inputData, globalInputs: updatedGlobalInputs});
  }

  return <Container>
    {renderHeaderSection &&<div style={{marginBottom: "20px", position: "relative"}}>
      <h2>Global Inputs</h2>
      <LoadfromDataSourceBtn variant="global-inputs" projectVersions={inputData.projectVersions} config={config} onDataLoaded={(updatedGlobalInputs) => {
        handleOnValuesUpdated(updatedGlobalInputs);
      }} />
    </div>}
    <Grid>{config && <LocatorsMapInput
        inputValues={globalInputs}
        mappingConfig={config.mappingConfig}
        onValuesUpdated={handleOnValuesUpdated}
        compact={compact}
        sectioningByWorksheet={sectioningByWorksheet}
        useDatePickersForDateInputs={useDatePickersForDateInputs}
    />}
    </Grid>
  </Container>
}